import { render, staticRenderFns } from "./CustomLeads.vue?vue&type=template&id=3f777048&"
import script from "./CustomLeads.vue?vue&type=script&lang=js&"
export * from "./CustomLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports